import { ApiClient } from '@webapp/core/services/ApiClient'
import { LinkedBankAccountRepository } from './LinkedBankAccountRepository'

export const linkedBankAccountRepository = new LinkedBankAccountRepository({
  httpClient: ApiClient,
})
